import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TrVirtualKeyboardButtonComponent } from './tr-virtual-keyboard-button.component';
import { MoneyPipeModule } from '../../pipes/money/money.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MoneyPipeModule,
    ],
    exports: [ TrVirtualKeyboardButtonComponent],
    declarations: [ TrVirtualKeyboardButtonComponent],
})
export class TrVirtualKeyboardButtonModule {}
